import { getParent, types } from 'mobx-state-tree';
import { api } from 'src/api';
import { createAsync } from 'src/utils/asyncModel';
const updateUnitsAsync = createAsync(body => {
  return async function updateUnits(options) {
    const resp = await api.Units.updateUnits(body, options);
    return resp;
  };
});
const updateUnitPmsMappingsAsync = createAsync(body => {
  return async function updateUnitPmsMappings(options) {
    const resp = await api.Units.updateUnitPmsMappings(body, options);
    return resp;
  };
});
const getUnitsAsync = createAsync(body => {
  return async function getUnits(options) {
    var _getParent$homeDashbo;
    const applyToHomeDashboard = body.applyToHomeDashboard;
    delete body.applyToHomeDashboard;
    const target = applyToHomeDashboard ? (_getParent$homeDashbo = getParent(this).homeDashboardStore.getCurrentCompany) === null || _getParent$homeDashbo === void 0 ? void 0 : _getParent$homeDashbo.selectedPropertyDetails().details : null;
    const resp = await api.Units.getUnits(body, options);
    const _getParent = getParent(this),
      addNewProperty = _getParent.addNewProperty;
    addNewProperty.unitSetup.changeSavedUnits(resp, '0');
    const _getParent2 = getParent(this),
      units = _getParent2.units;
    units.setUnitsAfterLoad(resp);
    if (target) {
      target.unitSetup.setUnitsAfterLoad(resp);
      target.unitSetup.changeSavedUnits(resp);
    }
    return resp;
  };
});
const getUnitsExtendedAsync = createAsync(body => {
  return async function getUnitsExtended(options) {
    const resp = await api.Units.getUnitsExtended(body, options);
    const _getParent3 = getParent(this),
      enrollResident = _getParent3.enrollResident;
    enrollResident.assignSearchedUnits(resp);
    return resp;
  };
});
const getUnitByIdAsync = createAsync(body => {
  return async function getUnitById(options) {
    const resp = await api.Units.getUnitById(body, options);
    return resp;
  };
});
const getUnitAvailabilityByIdAsync = createAsync(body => {
  return async function getUnitAvailabilityById(options) {
    const resp = await api.Units.getUnitAvailabilityById(body, options);
    return resp;
  };
});
const InUnitAmenities = types.model('InUnitAmenities', {
  inUnitAmenityId: types.optional(types.string, ''),
  inUnitAmenityOptionId: types.optional(types.string, '')
});
const Unit = types.model('Unit', {
  id: types.optional(types.string, ''),
  inUnitAmenities: types.optional(types.array(InUnitAmenities), []),
  name: types.optional(types.string, ''),
  occupancy: types.optional(types.number, 0),
  squareFootage: types.optional(types.number, 0),
  type: types.optional(types.string, 'None'),
  utilityIds: types.optional(types.array(types.string), [])
});
const UnitsStore = types.model('UnitsStore', {
  units: types.optional(types.array(Unit), []),
  getUnitByIdAsync,
  getUnitsAsync,
  getUnitsExtendedAsync,
  updateUnitsAsync,
  updateUnitPmsMappingsAsync,
  getUnitAvailabilityByIdAsync
}).actions(self => ({
  setUnitsAfterLoad(resp) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const data = [...resp.response].sort((a, b) => a.name > b.name ? 1 : a.name < b.name ? -1 : 0);
    try {
      self.units = data;
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  }
})).views(self => ({
  get unitsList() {
    return self.units;
  }
}));
export const units = types.optional(UnitsStore, {});